import { render, staticRenderFns } from "./TableColumnMovement.vue?vue&type=template&id=3f177708&scoped=true&"
import script from "./TableColumnMovement.vue?vue&type=script&lang=js&"
export * from "./TableColumnMovement.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnMovement.vue?vue&type=style&index=0&id=3f177708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f177708",
  null
  
)

export default component.exports